import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
import { MAP_DEFAULT_CONFIG } from "./consts.js";

/**
 * Google Maps を初期化して map 本体と AdvancedMarkerElement クラスを返す
 *
 * importLibrary("marker") はここで一度だけ呼び、
 * 返した AdvancedMarkerElement を markers.js / card.js に引数で渡して使い回す
 *
 * @param {Object} params
 * @param {HTMLElement} params.root - 地図を描画するコンテナ要素
 * @param {string} params.apiKey - Google Maps API キー
 * @param {string} params.mapId - Google Maps のマップ ID
 * @param {{ center: { lat: number, lng: number }, zoom: number }} params.view - 初期表示位置（consts.js の MAP_VIEWS から選択したもの）
 * @returns {Promise<{
 *   map: google.maps.Map,
 *   AdvancedMarkerElement: typeof google.maps.marker.AdvancedMarkerElement,
 * }>}
 */
export const initMap = async ({ root, apiKey, mapId, view }) => {
    setOptions({ key: apiKey, version: "weekly" });

    const { Map } = await importLibrary("maps");
    const { AdvancedMarkerElement } = await importLibrary("marker");

    const map = new Map(root, {
        ...MAP_DEFAULT_CONFIG,
        ...view,
        mapId,
    });

    return { map, AdvancedMarkerElement };
};
